import { render } from "./scatter_plot.vue?vue&type=template&id=6b129be6&scoped=true"
import script from "./scatter_plot.vue?vue&type=script&lang=js"
export * from "./scatter_plot.vue?vue&type=script&lang=js"

import "./scatter_plot.vue?vue&type=style&index=0&id=6b129be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b129be6"]])

export default __exports__